import { render, staticRenderFns } from "./DrTeam.vue?vue&type=template&id=648d2262&"
import script from "./DrTeam.vue?vue&type=script&lang=js&"
export * from "./DrTeam.vue?vue&type=script&lang=js&"
import style0 from "./DrTeam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports